<template>
  <div class="col-xl-12 text-start">
    <div class="card">
      <div class="card-header">
        <h5 class="mb-0 p-0">
          <button class="btn btn-link ps-0" data-bs-toggle="collapse" data-bs-target="#collapseicon2"
            :aria-expanded="isActive ? 'true' : 'false'" aria-controls="collapseicon2"
            :class="[isActive ? 'active' : '', 'collapsible']" v-on:click="toggle">Job Title</button>
        </h5>
      </div>
      <div :class="[isActive ? 'block' : 'none', 'content']" v-show="isActive">
        <div class="card-body animate-chk">
          <label class="d-block" for="chk-ani9">
            <input class="checkbox_animated" id="chk-ani9" type="checkbox"> UI/Ux designer(25)
          </label>
          <label class="d-block" for="chk-ani10">
            <input class="checkbox_animated" id="chk-ani10" type="checkbox">Graphic designer(10)
          </label>
          <label class="d-block" for="chk-ani11">
            <input class="checkbox_animated" id="chk-ani11" type="checkbox">Front end designer(15)
          </label>
          <label class="d-block" for="chk-ani12">
            <input class="checkbox_animated" id="chk-ani12" type="checkbox">PHP developer(42)
          </label>
          <label class="d-block mb-0" for="chk-ani13">
            <input class="checkbox_animated" id="chk-ani13" type="checkbox">React Developer( 5 )
          </label>
        </div>
        <button class="btn btn-block btn-primary text-center" type="button">All Job Title</button>
      </div>
    </div>
  </div>
  <div class="col-xl-12 text-start">
    <div class="card">
      <div class="card-header">
        <h5 class="mb-0 p-0">
          <button class="btn btn-link ps-0" data-bs-toggle="collapse" data-bs-target="#collapseicon3"
            :aria-expanded="isActive1 ? 'true' : 'false'" aria-controls="collapseicon3"
            :class="[isActive1 ? 'active' : '', 'collapsible']" v-on:click="toggle1">Industry</button>
        </h5>
      </div>
      <div :class="[isActive1 ? 'block' : 'none', 'content']" v-show="isActive1">
        <div class="card-body animate-chk">
          <label class="d-block" for="chk-ani14">
            <input class="checkbox_animated" id="chk-ani14" type="checkbox">Computer Software(14)
          </label>
          <label class="d-block" for="chk-ani15">
            <input class="checkbox_animated" id="chk-ani15" type="checkbox">IT Engineer(10)
          </label>
          <label class="d-block" for="chk-ani16">
            <input class="checkbox_animated" id="chk-ani16" type="checkbox"> Service industry(20)
          </label>
          <label class="d-block" for="chk-ani17">
            <input class="checkbox_animated" id="chk-ani17" type="checkbox">Accounting ( 34 )
          </label>
          <label class="d-block mb-0" for="chk-ani18">
            <input class="checkbox_animated" id="chk-ani18" type="checkbox">Financial Services(5)
          </label>
        </div>
        <button class="btn btn-block btn-primary text-center" type="button">All Industries</button>
      </div>
    </div>
  </div>
  <specificSkills />
</template>
<script>
import specificSkills from "./specificSkills.vue"
export default {
  components: {
    specificSkills
  },
  data() {
    return {
      isActive: true,
      isActive1: true,
    }
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive
    },
    toggle1() {
      this.isActive1 = !this.isActive1
    },
  }
}
</script>
